import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { db } from '../firebaseConfig';
import { doc, getDoc, collection, query, where, getDocs, orderBy, limit, updateDoc, setDoc, increment,} from 'firebase/firestore';
import LatestSidebar from '../Components/LatestSidebar';
import { FaCalendarAlt, FaClock, FaFacebookF, FaTwitter, FaWhatsapp, FaLinkedinIn, FaTelegramPlane } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Comments from "../Components/Comments";

const NewsDetails = () => {
  const { categorySlug, subcategorySlug, id } = useParams();
  const [news, setNews] = useState(null);
const [openedNews, setOpenedNews] = useState([]);
const [relatedNewsMap, setRelatedNewsMap] = useState({});
const [inlineNewsList, setInlineNewsList] = useState([]);


const getRelatedNews = async (newsItem, usedIds, allCategoryNews, count = 5) => {
    const relatedMap = new Map();

    const filterAndAdd = (list) => {
      for (const d of list) {
        if (d.id === newsItem.id) continue;
        if (usedIds.has(d.id)) continue;
        if (relatedMap.has(d.id)) continue;

        relatedMap.set(d.id, d);
        if (relatedMap.size >= count) break;
      }
    };

    // ---------- ১. Strict Subcategory matching ----------
    // যদি সাব-ক্যাটেগরি থাকে, তবে শুধু হুবহু একই সাব-ক্যাটেগরির নিউজগুলোই নেবে (ক্রিকেট হলে শুধু ক্রিকেট)
    if (newsItem.subcategory) {
      const subMatched = allCategoryNews.filter(d => 
        d.id !== newsItem.id && 
        d.subcategory && 
        d.subcategory.trim().toLowerCase() === newsItem.subcategory.trim().toLowerCase()
      );
      filterAndAdd(subMatched);
    }

    // ---------- ২. Tag matching ----------
    if (relatedMap.size < count && newsItem.tags?.length) {
      const targetTags = newsItem.tags.slice(0, 5);
      const tagMatched = allCategoryNews.filter(d => 
        d.id !== newsItem.id && 
        d.tags && 
        d.tags.some(t => targetTags.includes(t)) &&
        // যদি সাব-ক্যাটেগরি থাকে, তবে ট্যাগ ম্যাচ করার সময়ও সাব-ক্যাটেগরি সেম থাকা বাধ্যতামূলক করব (ক্রস-স্পোর্টস এড়াতে)
        (!newsItem.subcategory || d.subcategory === newsItem.subcategory)
      );
      filterAndAdd(tagMatched);
    }

    // ---------- ৩. Category matching (Fallback - তবে সাব-ক্যাটেগরি না থাকলে বা মিললে) ----------
    if (relatedMap.size < count && newsItem.category) {
      const catMatched = allCategoryNews.filter(d => 
        d.id !== newsItem.id && 
        d.category === newsItem.category &&
        (!newsItem.subcategory || d.subcategory === newsItem.subcategory) // ক্রস ক্যাটেগরি মিক্সিং ব্লক করার জন্য
      );
      filterAndAdd(catMatched);
    }

    return Array.from(relatedMap.values()).slice(0, count);
  };

 useEffect(() => {
    const fetchNewsAndCategoryList = async () => {
      setNews(null);
      setOpenedNews([]);

      // ১. প্রথমে যে নিউজটিতে ক্লিক করা হয়েছে সেটির ডেটা আনা
      const docRef = doc(db, "news", id);
      const docSnap = await getDoc(docRef);

      if (!docSnap.exists()) return;

      try {
        await updateDoc(docRef, { views: increment(1) });
      } catch (e) {
        console.error(e);
      }

      const clickedNewsData = {
        id: docSnap.id,
        ...docSnap.data(),
      };

      setNews(clickedNewsData);

      // ২. ওই একই ক্যাটেগরির লেটেস্ট নিউজগুলো একবারে বেশি করে নিয়ে আসা (যাতে পর্যাপ্ত পুল থাকে)
      let allCategoryNews = [];
      if (clickedNewsData.category) {
        const catQuery = query(
          collection(db, "news"),
          where("category", "==", clickedNewsData.category),
          orderBy("timestamp", "desc"),
          limit(30) // একবারে ৩০টি নিউজ এনে মেমোরিতে রাখা হলো
        );

        const catSnap = await getDocs(catQuery);
        catSnap.forEach((d) => {
          allCategoryNews.push({
            id: d.id,
            ...d.data(),
          });
        });
      }

      // ৩. ক্যাটেগরির লিস্ট থেকে প্রথম ৫টি নিউজ সিলেক্ট করা (ক্লিক করা নিউজটি সহ)
      let categoryNewsList = [clickedNewsData];
      for (const d of allCategoryNews) {
        if (d.id !== clickedNewsData.id && categoryNewsList.length < 5) {
          categoryNewsList.push(d);
        }
      }

      // ৪. স্টেট আপডেট এবং সিকোয়েন্সিয়ালি usedIds মেইনটেইন করে রিলেটেড ম্যাপ তৈরি
      setOpenedNews(categoryNewsList);

      const openedIds = new Set(categoryNewsList.map(n => n.id));
      const usedIds = new Set(openedIds);
      const allRelated = {};

      for (const opened of categoryNewsList) {
        // মেমোরি বেসড ফাংশনে অলরেডি ফেচ করা ক্যাটেগরি লিস্ট পাস করা হলো
        const list = await getRelatedNews(opened, usedIds, allCategoryNews);
        allRelated[opened.id] = list;

        list.forEach(item => {
          usedIds.add(item.id);
        });
      }

      setRelatedNewsMap(allRelated);
	   const inlineList = await getRelatedNews(clickedNewsData, usedIds, allCategoryNews, 2);
	   setInlineNewsList(inlineList);
    };
   
    fetchNewsAndCategoryList();
  }, [id]);

  if (!news) return <div style={{ padding: '50px', textAlign: 'center' }}>লোড হচ্ছে...</div>;


return (
  <HelmetProvider>
   <Helmet>
    <title>{news?.title || "ভাওয়াইয়া এক্সপ্রেস"}</title>
    <link rel="canonical" href={`https://vawaiyaexpress.com/${categorySlug}/${subcategorySlug}/${id}`} />

    <meta property="og:title" content={news?.title} />
    <meta property="og:description" content={news?.content?.substring(0, 150)} />
    <meta property="og:image" content={news?.image} />
    <meta property="og:url" content={`https://vawaiyaexpress.com/${categorySlug}/${subcategorySlug}/${id}`} />
    <meta property="og:type" content="article" />
     
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={news.title} />
    <meta name="twitter:description" content={news.content.substring(0, 150)} />
    <meta name="twitter:image" content={news.image} />
   </Helmet>
  
   <div key={id} style={{ maxWidth: '1400px', margin: '0 auto' }}>
  {openedNews.map((item, index) => {
       const currentUrl = window.location.origin + `/${item.categorySlug || 'general'}/${item.subcategorySlug || 'general'}/${item.id}`;
       const title = item.title;

       const shareLinks = {
         facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`,
         twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(title)}`,
         whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(title + ' - ' + currentUrl)}`,
         linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(currentUrl)}&title=${encodeURIComponent(title)}`,
         telegram: `https://t.me/share/url?url=${encodeURIComponent(currentUrl)}&text=${encodeURIComponent(title)}`
       };

       const platforms = [
         { name: 'Facebook', icon: <FaFacebookF />, color: '#1877F2', url: shareLinks.facebook },
		 { name: 'X (Twitter)', icon: <FaXTwitter />, color: '#000000', url: shareLinks.twitter },
         { name: 'Twitter', icon: <FaTwitter />, color: '#1DA1F2', url: shareLinks.twitter },
         { name: 'WhatsApp', icon: <FaWhatsapp />, color: '#25D366', url: shareLinks.whatsapp },
         { name: 'LinkedIn', icon: <FaLinkedinIn />, color: '#0A66C2', url: shareLinks.linkedin },
         { name: 'Telegram', icon: <FaTelegramPlane />, color: '#229ED9', url: shareLinks.telegram },
       ];

       return (
       <div key={`${item.id}-${index}`} style={{ display: 'flex', gap: '30px', padding: '20px', alignItems: 'flex-start', borderBottom: '5px solid #f0f0f0' }}>
          
          {/* ১. বাম সাইডবার */}
          <aside style={{ width: '18%', flexShrink: 0, position: 'sticky', top: '20px' }}>
            {index === 0 && (
              <div style={{ borderLeft: '5px solid #d2202a', paddingLeft: '15px', marginBottom: '30px' }}>
                <Link to={`/category/${item.categorySlug || 'general'}`} style={{ textDecoration: 'none', fontSize: '22px', fontWeight: 'bold', color: '#000' }}>
                  {item.category}
                </Link>
              </div>
            )}
            
            <h4 style={{ borderBottom: '2px solid #d2202a', paddingBottom: '5px', color: '#000', fontSize: '20px', marginBottom: '20px' }}>
              এ সম্পর্কিত আরো খবর
            </h4>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {(relatedNewsMap[item.id] || []).map(rel => (
                <div key={rel.id}>
                <Link key={rel.id} to={`/${rel.categorySlug || 'general'}/${rel.subcategorySlug || 'general'}/${rel.id}`}
                    style={{ textDecoration: 'none', color: '#333333', display: 'flex', gap: '10px', alignItems: 'flex-start' }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#4169E1'}
                    onMouseOut={(e) => e.currentTarget.style.color = '#333333'}
                  >
                    <img src={rel.imageUrl || rel.image} alt={rel.title} style={{ width: '70px', height: '50px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} />
                    <span style={{ fontSize: '16px', fontWeight: 'bold' }}>{rel.title}</span>
                  </Link>
                </div>
              ))}
            </div>
          </aside>

   {/* ২. মেইন নিউজ কন্টেন্ট */}
     <main style={{ flexGrow: 1 }} key={id}>  
       <h1 style={{ fontSize: '34px', lineHeight: '1.3', marginBottom: '15px' }}>
         {item.title}
       </h1>
      
 {/* প্রতিবেদকের নাম এবং সোশ্যাল শেয়ার আইকন এক লাইনে */}
     <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', marginBottom: '20px', gap: '15px' }}>
       
       {/* বাম পাশ: প্রতিবেদক এবং তারিখ-সময় */}
       <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
         {/* প্রতিবেদকের নাম */}
         <div style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#333', fontWeight: 'bold' }}>
           <span style={{ fontSize: '14px' }}></span>
           <span style={{ fontSize: '14px', color: '#0056b3' }}>
             {item.reporterName || ''}
           </span>
         </div>
         
         {/* তারিখ ও সময় */}
         <div style={{ display: 'flex', gap: '15px', color: '#777', fontSize: '13px' }}>
           <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
             <FaCalendarAlt /> 
             {item.timestamp ?  
               new Date(item.timestamp.seconds * 1000).toLocaleDateString('bn-BD', {  
                 day: '2-digit',  
                 month: 'long',  
                 year: 'numeric'  
               })  
               : 'তারিখ নেই'}
           </span>
           <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
             <FaClock /> {item.timestamp ? new Date(item.timestamp.seconds * 1000).toLocaleTimeString('bn-BD', { hour: '2-digit', minute: '2-digit' }) : 'সময় নেই'}
           </span>
         </div>
       </div>

       {/* ডান পাশ: সোশ্যাল শেয়ার আইকনগুলো */}
       <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
         <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#555' }}>শেয়ার করুন:</span>
         <div style={{ display: 'flex', gap: '6px' }}>
           {platforms.map((p, pIndex) => (
             <a  
               key={pIndex}
               href={p.url} 
               target="_blank" 
               rel="noopener noreferrer" 
               title={`${p.name} এ শেয়ার করুন`}
               style={{
                 display: 'inline-flex',
                 alignItems: 'center',
                 justifyContent: 'center',
                 width: '32px',
                 height: '32px',
                 backgroundColor: p.color, 
                 color: '#ffffff',             
                 borderRadius: '50%',
                 textDecoration: 'none',
                 fontSize: '14px',
                 transition: 'all 0.3s ease-in-out',
                 boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
               }}
               onMouseEnter={(e) => {
                 e.currentTarget.style.transform = 'translateY(-3px)'; 
               }}
               onMouseLeave={(e) => {
                 e.currentTarget.style.transform = 'translateY(0)';
               }}
             >
               {p.icon}
             </a>
           ))}
         </div>
       </div>

     </div>
	  
          {/* ছবি ও ক্যাপশন */}
  <div style={{ marginBottom: '25px' }}>
    <img 
      src={item.image} 
      alt={item.title} 
      loading="lazy"
      style={{ 
        width: '100%', 
        maxHeight: '400px', 
        objectFit: 'cover', 
        borderRadius: '8px' 
      }} 
    />
    {item.caption && (
      <p style={{ 
        fontSize: '13px', 
        color: '#555', 
        fontStyle: 'italic', 
        marginTop: '10px', 
        textAlign: 'center' 
      }}>
        {item.caption}
      </p>
    )}
  </div>

{/* মূল খবর এবং ইনলাইন রিলেটেড নিউজ */}
<div style={{ 
    fontSize: '19px', 
    lineHeight: '1.7', 
    color: '#333333', 
    textAlign: 'justify',
    marginBottom: '20px' 
  }}>
    {item.content.split('\n').filter(p => p.trim() !== "").map((paragraph, pIndex) => {
      // কালবেলার স্টাইলে ২য় প্যারাগ্রাফের পর (pIndex === 1) ইনলাইন নিউজ বক্স দেখাবে
      const showInlineBox = pIndex === 1 && inlineNewsList && inlineNewsList[0];

      return (
        <React.Fragment key={pIndex}>
          <p style={{ marginBottom: '20px', marginTop: '0' }}>
            {paragraph}
          </p>

          {showInlineBox && (
            <div style={{
              border: '1px solid #e2e8f0',
              borderLeft: '4px solid #ef4444',
              padding: '12px 16px',
              margin: '24px 0',
              backgroundColor: '#f8fafc',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              gap: '15px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
            }}>
              <img 
                src={inlineNewsList[0].imageUrl || inlineNewsList[0].image} 
                alt={inlineNewsList[0].title} 
                style={{ width: '100px', height: '65px', objectFit: 'cover', borderRadius: '4px', flexShrink: 0 }} 
              />
              <div>
                <span style={{ fontSize: '12px', color: '#ef4444', fontWeight: 'bold', display: 'block', marginBottom: '4px' }}>আরও পড়ুন</span>
                <Link 
                  to={`/${inlineNewsList[0].categorySlug || 'news'}/${inlineNewsList[0].id}`}
                  style={{ textDecoration: 'none', color: '#1e293b', fontSize: '16px', fontWeight: '600', lineHeight: '1.4' }}
                >
                  {inlineNewsList[0].title}
                </Link>
              </div>
            </div>
          )}
        </React.Fragment>
      );
    })}
</div>

{item.tags && item.tags.length > 0 && (
  <div
    style={{
      marginTop: "30px",
      paddingTop: "15px",
      borderTop: "1px solid #ddd",
    }}
  >
    <strong style={{ marginRight: "10px" }}>কী-ওয়ার্ড:</strong>

    {item.tags.map((tag, index) => (
      <Link
        key={index}
        to={`/tag/${encodeURIComponent(tag)}`}
        style={{
          display: "inline-block",
          marginRight: "8px",
          marginBottom: "8px",
          padding: "6px 12px",
          background: "#f3f3f3",
          color: "#333",
          textDecoration: "none",
          borderRadius: "20px",
          fontSize: "15px",
          transition: "0.2s",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#d2202a";
          e.currentTarget.style.color = "#fff";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#f3f3f3";
          e.currentTarget.style.color = "#333";
        }}
      >
        {tag}
      </Link>
    ))}
  </div>
)}

<Comments newsId={item.id} />
          </main>

       <aside style={{ width: '20%', flexShrink: 0, position: 'sticky', top: '20px' }}>
             <div style={{ width: '100%', height: '200px', backgroundColor: '#f0f0f0', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px dashed #ccc' }}>বিজ্ঞাপন</div>
             <LatestSidebar />
           </aside>
         </div>
       );
     })}
   </div>
  </HelmetProvider>
  );
};

export default NewsDetails;